var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "prefix__a",
    width: "105.3%",
    height: "109.2%",
    x: "-2.7%",
    y: "-2.3%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowOffsetOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "prefix__b",
    d: "M17.37 8.363L4.526.447C3.597-.125 2.474-.15 1.521.383.57.915 0 1.884 0 2.975v15.762c0 1.65 1.33 3 2.963 3.008h.013c.511 0 1.043-.16 1.54-.463.4-.244.526-.766.282-1.166-.244-.4-.765-.526-1.165-.282-.233.142-.46.215-.66.215-.617-.003-1.277-.531-1.277-1.312V2.975c0-.468.244-.883.652-1.112.409-.228.89-.218 1.289.027L16.48 9.807c.386.238.607.634.606 1.088 0 .453-.223.848-.611 1.085l-9.286 5.686c-.4.244-.525.766-.28 1.166.244.399.766.524 1.165.28l9.285-5.685c.889-.542 1.42-1.488 1.423-2.529.002-1.041-.526-1.989-1.412-2.535z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#prefix__a)",
    xlinkHref: "#prefix__b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#prefix__b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlay);
export default __webpack_public_path__ + "static/media/icon-play.d2ab804acfa5482a96da56e1d1ba0720.svg";
export { ForwardRef as ReactComponent };